/* ============
 * ChartOfAccounts Transformer
 * ============
 *
 * The transformer for the chartOfAccounts
 */

import Transformer from './transformer';

export default class ChartOfAccountsTransformer extends Transformer {

  static fetch(elem) {
    return {
      id: elem.id,
      code: elem.code,
      name: elem.name,
      description: elem.description,
    };
  }

  static send(elem) {
    return {
      id: elem.id,
      code: elem.code,
      name: elem.name,
      description: elem.description,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/chartOfAccounts.js